import { useNavigate } from 'react-router-dom';
import { ReactNode } from 'react';
import { clsx } from 'clsx';
import styles from './EditEntityModal.module.scss';
import { Button, ButtonProps } from '../../../button/Button';
import { EditingBadge } from '../EditingBadge/EditingBadge';

interface EditEntityWizardProps {
  name: string;
  submitButtonProps: Partial<ButtonProps>;
  children: ReactNode;
  cancelUrl: string;
  isCancelUrlPathRelative: boolean;
}

export function EditEntityWizard({
  name,
  submitButtonProps,
  children,
  cancelUrl,
  isCancelUrlPathRelative
}: EditEntityWizardProps) {
  const navigate = useNavigate();

  const onCancel = () => {
    navigate(cancelUrl, { replace: true, relative: isCancelUrlPathRelative ? 'path' : 'route' });
  };

  return (
    <div className='main-content-area' data-id='edit-entity-wizard'>
      <div className={clsx(styles.editEntityModalHeader)}>
        <span className='text-subheading-2 text-ellipsis' data-id='name'>
          {name}
        </span>

        <EditingBadge className='ml-2' />
      </div>

      <div className='flex-1 overflow-hidden bg-surface-alternate'>{children}</div>

      <div className={clsx(styles.editEntityModalFooter)}>
        <Button
          dataId='cancel'
          icon='close'
          direction='left'
          variation='outline'
          size='sm'
          className='mr-5'
          onClick={onCancel}
        >
          Cancel
        </Button>

        <Button dataId='submit' size='sm' {...submitButtonProps}>
          Test & Save
        </Button>
      </div>
    </div>
  );
}
